import React, { useState } from "react";

interface MediaItemProps {
  id: number;
  description: string;
  imgUrl: string;
  videoUrl?: string;
  className?: string;
  openModal: () => void;
  isLoaded: boolean;
  onLoadingComplete: (id: number) => void;
}

const HEIGHT_SLIDER = 600;

const getVimeoId = (url: string): string => {
  const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return match ? match[1] : "";
};

const MediaItem: React.FC<MediaItemProps> = ({
  id,
  description,
  imgUrl,
  videoUrl,
  className,
  openModal,
  isLoaded,
  onLoadingComplete,
}) => {
  const [aspectRatio, setAspectRatio] = useState(1);

  const handleImageLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
    const { naturalWidth, naturalHeight } = event.currentTarget;
    setAspectRatio(naturalWidth / naturalHeight);
    if (!isLoaded) {
      onLoadingComplete(id);
    }
  };

  return (
    <div
      className={`relative cursor-pointer ${className}`}
      onClick={openModal}
      style={{ height: HEIGHT_SLIDER }}
    >
      {videoUrl ? (
        <div className="w-[86rem] h-full flex items-center justify-center bg-black bg-opacity-50 relative">
          <iframe
            src={`https://player.vimeo.com/video/${getVimeoId(
              videoUrl
            )}?title=0&byline=0&portrait=0&badge=0&autopause=0&controls=0`}
            className="absolute w-full h-full rounded-lg"
            allow="fullscreen; picture-in-picture"
            allowFullScreen
            title="Vimeo preview"
          />
          <button
            className="text-white text-[3rem] z-10"
            onClick={(e) => {
              e.stopPropagation();
              openModal();
            }}
          >
            ▶
          </button>
        </div>
      ) : (
        <img
          src={imgUrl}
          alt={description}
          width={HEIGHT_SLIDER * aspectRatio || HEIGHT_SLIDER}
          height={HEIGHT_SLIDER}
          onLoad={handleImageLoad}
          className="object-cover"
        />
      )}
    </div>
  );
};

export default MediaItem;
